import { activityLog } from './activityLog';
import { AuthenticationLog } from './authenticationLog';

export const logging = { ...AuthenticationLog, ...activityLog };
